import { PostAPI } from 'Components/Helper/Helpers';


export const TerminalRegister = async (request) => {
    return PostAPI(request, 'OnlyApiAEPS/TerminalRegister');
};

export const Authentication = async (request) => {
    return PostAPI(request, 'OnlyApiAEPS/TwoFaAuthentication');
};

export const CashWithdrawal = async (request) => {
    return PostAPI(request, 'OnlyApiAEPS/CashWithdrawal');
};

export const BalanceEnquiry = async (request) => {
    return PostAPI(request, 'OnlyApiAEPS/BalanceEnquiry');
};

export const MiniStatement = async (request) => {
    return PostAPI(request, 'OnlyApiAEPS/MiniStatement');
};